export const FETCH_APP_NAVIGATION_SUCCEEDED = 'src/constants/FETCH_APP_NAVIGATION_SUCCEEDED';

export const ARCHIVED_MODE_MENU_ITEMS = ['Find', 'Dashboard'];

export const ADMIN_NAVIGATION_ITEMS = ['AdminMenu', 'ModuleAdminMenu', 'SystemSetupMenu'];
